var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.typeId == 'integer')?_c('integer-field',{attrs:{"parameter":_vm.parameter},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }